import { gql } from '@apollo/client';

export const CreateCustomerMortgageLead = gql`
  mutation CreateCustomerMortgageLead($customerUuid: String!) {
    customerFinancingService {
      createCustomerMortgageLead(input: { customerUuid: $customerUuid }) {
        mortgageLead {
          mortgageLeadId
        }
      }
    }
  }
`;
